import { A_Error } from "@adaas/a-concept";



export class AreSyntaxError extends A_Error {

    static readonly SyntaxParseError = 'Are Syntax Parse Error';
    static readonly SyntaxNotSupportedError = 'Are Syntax Not Supported Error';
    static readonly MethodNotImplementedError = 'Are Syntax Method Not Implemented Error';

}